import type {AddTaskFormPayload} from "./add-task.schema";

import {addTask} from "@project/sdk/admin";
import {mutationOptions} from "@tanstack/react-query";

import {userMutationKeys} from "../../../../user-keys";

import {addTaskMapper} from "./add-task.mapper";

/**
 * Mutation option factory for adding a task to a user.
 *
 * Declares the mutationKey (for DevTools + setMutationDefaults targeting) and
 * the mutationFn. Cache invalidation (onSuccess) belongs in the hook layer.
 *
 * @param userId - The ID of the user to add the task to
 */
export function addTaskMutationOptions(userId: string) {
  return mutationOptions({
    mutationFn: (payload: AddTaskFormPayload) => {
      const request = addTaskMapper.toSdk(payload);

      return addTask(userId, request);
    },
    mutationKey: userMutationKeys.addTask(),
  });
}
